/* tslint:disable */
/* eslint-disable */

// @ts-ignore
import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// @ts-ignore
import type { ConfigurationParameters } from '../configuration';
// @ts-ignore
import { Configuration as OpenApiGeneratorConfiguration } from '../configuration';
// @ts-ignore
import type { AxiosError, AxiosResponse } from 'axios';
import {
    useQuery,
    UseMutationOptions,
    useMutation,
    UseQueryOptions
    // @ts-ignore
} from 'react-query';
// @ts-ignore
import { useAuthorizationToken, useAuthQueryKey, useApiBasePath } from '../../utils';
// Some imports not used depending on template conditions
// @ts-ignore
import {
    DUMMY_BASE_URL,
    assertParamExists,
    setApiKeyToObject,
    setBasicAuthToObject,
    setBearerAuthToObject,
    setOAuthToObject,
    setSearchParams,
    serializeDataIfNeeded,
    toPathString,
    createRequestFunction
} from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { RmsLoggedUserDto } from '../models';
// @ts-ignore
import { UserSettingsUpdateDto } from '../models';
/**
 * RmsUserManagementWebServicesApi - axios parameter creator
 * @export
 */
export const RmsUserManagementWebServicesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshAndRetrieveUserConfiguration: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {UserSettingsUpdateDto} userSettingsUpdateDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserSettings: async (
            userSettingsUpdateDto: UserSettingsUpdateDto,
            options: AxiosRequestConfig = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'userSettingsUpdateDto' is not null or undefined
            assertParamExists('updateUserSettings', 'userSettingsUpdateDto', userSettingsUpdateDto);
            const localVarPath = `/user/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = serializeDataIfNeeded(
                userSettingsUpdateDto,
                localVarRequestOptions,
                configuration
            );

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};

/**
 * RmsUserManagementWebServicesApi - functional programming interface
 * @export
 */
export const RmsUserManagementWebServicesApiFp = function (configuration?: Configuration) {
    const localVarAxiosParamCreator = RmsUserManagementWebServicesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshAndRetrieveUserConfiguration(
            options?: AxiosRequestConfig
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RmsLoggedUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshAndRetrieveUserConfiguration(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, configuration?.basePath, configuration);
        },
        /**
         *
         * @param {UserSettingsUpdateDto} userSettingsUpdateDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserSettings(
            userSettingsUpdateDto: UserSettingsUpdateDto,
            options?: AxiosRequestConfig
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RmsLoggedUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserSettings(
                userSettingsUpdateDto,
                options
            );
            return createRequestFunction(localVarAxiosArgs, globalAxios, configuration?.basePath, configuration);
        }
    };
};

/**
 * RmsUserManagementWebServicesApi - factory interface
 * @export
 */
export const RmsUserManagementWebServicesApiFactory = function (
    configuration?: Configuration,
    basePath?: string,
    axios?: AxiosInstance
) {
    const localVarFp = RmsUserManagementWebServicesApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshAndRetrieveUserConfiguration(options?: AxiosRequestConfig): AxiosPromise<RmsLoggedUserDto> {
            return localVarFp.refreshAndRetrieveUserConfiguration(options).then(request => request(axios, basePath));
        },
        /**
         *
         * @param {RmsUserManagementWebServicesApiUpdateUserSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserSettings(
            requestParameters: RmsUserManagementWebServicesApiUpdateUserSettingsRequest,
            options?: AxiosRequestConfig
        ): AxiosPromise<RmsLoggedUserDto> {
            return localVarFp
                .updateUserSettings(requestParameters.userSettingsUpdateDto, options)
                .then(request => request(axios, basePath));
        }
    };
};

/**
 * Request parameters for updateUserSettings operation in RmsUserManagementWebServicesApi.
 * @export
 * @interface RmsUserManagementWebServicesApiUpdateUserSettingsRequest
 */
export interface RmsUserManagementWebServicesApiUpdateUserSettingsRequest {
    /**
     *
     * @type {UserSettingsUpdateDto}
     * @memberof RmsUserManagementWebServicesApiUpdateUserSettings
     */
    readonly userSettingsUpdateDto: UserSettingsUpdateDto;
}

/**
 * RmsUserManagementWebServicesApi - object-oriented interface
 * @export
 * @class RmsUserManagementWebServicesApi
 * @extends {BaseAPI}
 */
export class RmsUserManagementWebServicesApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RmsUserManagementWebServicesApi
     */
    public refreshAndRetrieveUserConfiguration(options?: AxiosRequestConfig) {
        return RmsUserManagementWebServicesApiFp(this.configuration)
            .refreshAndRetrieveUserConfiguration(options)
            .then(request => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {RmsUserManagementWebServicesApiUpdateUserSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RmsUserManagementWebServicesApi
     */
    public updateUserSettings(
        requestParameters: RmsUserManagementWebServicesApiUpdateUserSettingsRequest,
        options?: AxiosRequestConfig
    ) {
        return RmsUserManagementWebServicesApiFp(this.configuration)
            .updateUserSettings(requestParameters.userSettingsUpdateDto, options)
            .then(request => request(this.axios, this.basePath));
    }
}

// custom hook generation here
export type GetRefreshAndRetrieveUserConfigurationResponse = AxiosResponse<RmsLoggedUserDto>;
export const KeyGetRefreshAndRetrieveUserConfiguration = 'GetRefreshAndRetrieveUserConfiguration';
export const useMutationGetRefreshAndRetrieveUserConfiguration = (
    options?: UseMutationOptions<GetRefreshAndRetrieveUserConfigurationResponse, AxiosError>,
    axiosConfig?: AxiosRequestConfig
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();

    const res = useMutation<GetRefreshAndRetrieveUserConfigurationResponse, AxiosError>(
        () =>
            new RmsUserManagementWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath
                })
            ).refreshAndRetrieveUserConfiguration(axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export const useQueryGetRefreshAndRetrieveUserConfiguration = (
    options?: UseQueryOptions<GetRefreshAndRetrieveUserConfigurationResponse, AxiosError>,
    axiosConfig?: AxiosRequestConfig,
    conf?: ConfigurationParameters
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();
    const authQueryKey = useAuthQueryKey();

    const res = useQuery<GetRefreshAndRetrieveUserConfigurationResponse, AxiosError>(
        [KeyGetRefreshAndRetrieveUserConfiguration, options && options.queryKey, authQueryKey],
        () =>
            new RmsUserManagementWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath,
                    ...conf
                })
            ).refreshAndRetrieveUserConfiguration(axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export type PatchUpdateUserSettingsResponse = AxiosResponse<RmsLoggedUserDto>;
export const KeyPatchUpdateUserSettings = 'PatchUpdateUserSettings';
export const useMutationPatchUpdateUserSettings = (
    options?: UseMutationOptions<
        PatchUpdateUserSettingsResponse,
        AxiosError,
        RmsUserManagementWebServicesApiUpdateUserSettingsRequest
    >,
    axiosConfig?: AxiosRequestConfig
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();

    const res = useMutation<
        PatchUpdateUserSettingsResponse,
        AxiosError,
        RmsUserManagementWebServicesApiUpdateUserSettingsRequest
    >(
        (args: RmsUserManagementWebServicesApiUpdateUserSettingsRequest) =>
            new RmsUserManagementWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath
                })
            ).updateUserSettings(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export const useQueryPatchUpdateUserSettings = (
    args: RmsUserManagementWebServicesApiUpdateUserSettingsRequest,
    options?: UseQueryOptions<PatchUpdateUserSettingsResponse, AxiosError>,
    axiosConfig?: AxiosRequestConfig,
    conf?: ConfigurationParameters
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();
    const authQueryKey = useAuthQueryKey();

    const res = useQuery<PatchUpdateUserSettingsResponse, AxiosError>(
        [KeyPatchUpdateUserSettings, args, options && options.queryKey, authQueryKey],
        () =>
            new RmsUserManagementWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath,
                    ...conf
                })
            ).updateUserSettings(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
